import * as Sentry from "@sentry/react";

function checkEnvironment(url: string) {
  const regex = /uploader\.(staging[0-9]\.)?steto\.care/;
  const match = url.match(regex);

  if (!match) {
    return "dev"; // No match
  } else if (!match[1]) {
    return "prod"; // Matched but no staging part (empty string)
  } else {
    return match[1].slice(0, -1); // Return the matched staging part without the trailing dot
  }
}

export const initSentry = () => {
  const env = checkEnvironment(window.origin);

  Sentry.init({
    dsn: "https://a8b21ff386eb54566d652ca3f0879991@o4508239595962368.ingest.de.sentry.io/4511303846002768",
    integrations: [Sentry.browserTracingIntegration()],
    release: import.meta.env["VITE_APP_RELEASE_NAME"],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ["localhost", /^https:\/\/uploader.(staging[0-9]\.){0,1}steto\.care/],
    environment: env,
  });
};
